import Dropdown from "app/components/Dropdown";
import { CheckIcon } from "app/components/Icons";
import Pill from "app/components/Pill";
import CustomTooltip from "app/components/Tooltip";
import React, { useMemo, useState, useEffect } from "react";
import { ITicketStatus } from "app/types";

interface Props {
  status: string;
  color: string;
  options: ITicketStatus[];
  onUpdate?: (newStatusId: string) => void;
}

const HomeStatus: React.FC<Props> = ({ status, color, options, onUpdate }) => {
  const [currentStatusId, setCurrentStatusId] = useState(status);

  useEffect(() => {
    if (status) {
      setCurrentStatusId(status);
    }
  }, [status]);

  const handleSelect = (data: ITicketStatus) => {
    setCurrentStatusId(data._id);
    onUpdate?.(data._id);
  };

  const selectedStatus = useMemo(() => {
    return (
      (options || []).find((s) => s._id === currentStatusId) ||
      (options || []).find((s) => s.name === status) ||
      (options || [])[0] || { name: status, color: color }
    );
  }, [currentStatusId, options, status, color]);

  const MenuItems = (options || []).map((option) => ({
    label: (
      <div className="flex items-center py-1 w-full">
        <span
          className="flex items-center justify-between text-white rounded-md w-full text-sm font-normal max-w-[168px] px-3 py-2"
          style={{ backgroundColor: option.color }}
        >
          <div className="w-full text-center">{option.name}</div>
          {option._id === currentStatusId && (
            <div className="min-w-[20px] flex justify-end ml-2">
              <CheckIcon color="#fff" />
            </div>
          )}
        </span>
      </div>
    ),
    action: () => handleSelect(option),
    isUnPaddedY: true,
  }));

  return (
    <React.Fragment>
      <Dropdown
        trigger={
          <button className="flex items-center justify-center hover:border hover:border-[#BDC0C3] p-[4px] rounded-[2px] cursor-pointer h-full outline-none w-full">
            <CustomTooltip
              text="Change status "
              position="bottom"
              className="w-full h-full"
            >
              <Pill
                className=" h-full w-full text-sm leading-[21px] font-normal rounded-[4px] !text-[#fff] "
                backgroundColor={color || selectedStatus.color}
                name={selectedStatus.name || status}
              />
            </CustomTooltip>
          </button>
        }
        menuItems={MenuItems}
        align="center"
        sideOffset={8}
        className="!w-[190px] !rounded-[4px] !p-0"
        dropDownClassName="hover:bg-[#fff]"
      />
    </React.Fragment>
  );
};

export default HomeStatus;
